/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_AnotherInputs */

const en_contact_form_another = /** @type {(inputs: Contact_Form_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write another`)
};

const pl_contact_form_another = /** @type {(inputs: Contact_Form_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napisz kolejną`)
};

/**
* | output |
* | --- |
* | "Write another" |
*
* @param {Contact_Form_AnotherInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_another = /** @type {((inputs?: Contact_Form_AnotherInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_AnotherInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_another(inputs)
	return en_contact_form_another(inputs)
});